module.exports = function() {
  return new Worker(__webpack_public_path__ + "e95167ac31693785f5b1.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
// module id = 2034
// module chunks = 1